import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  LANGUAGE_CODES,
  DEFAULT_LANGUAGE,
  APP_LANGUAGE_STORAGE_KEY,
} from './constants/languages';
import en from './locales/en.json';
import lv from './locales/lv.json';
import ru from './locales/ru.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import ee from './locales/ee.json';
import lt from './locales/lt.json';
import it from './locales/it.json';
import es from './locales/es.json';
import pt from './locales/pt.json';

const resources = {
  EN: { translation: en },
  LV: { translation: lv },
  RU: { translation: ru },
  FR: { translation: fr },
  DE: { translation: de },
  EE: { translation: ee },
  LT: { translation: lt },
  IT: { translation: it },
  ES: { translation: es },
  PT: { translation: pt },
};

const readStoredLanguage = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(APP_LANGUAGE_STORAGE_KEY);
  } catch {
    return null;
  }
};

const stored = readStoredLanguage();
const initialLanguage = LANGUAGE_CODES.includes(stored) ? stored : DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false }, // React already escapes
  returnEmptyString: false,
});

/**
 * Change the active language and persist the choice.
 * Ignores codes that are not in LANGUAGE_CODES.
 * @param {string} code
 */
export const setLanguage = (code) => {
  if (!LANGUAGE_CODES.includes(code)) return;
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(APP_LANGUAGE_STORAGE_KEY, code);
    } catch {
      // ignore quota / private mode
    }
  }
  i18n.changeLanguage(code);
};

/**
 * Active content language (UPPERCASE code).
 * @returns {string}
 */
export const getActiveLanguage = () => {
  const lng = (i18n.language || DEFAULT_LANGUAGE).toUpperCase().slice(0, 2);
  return LANGUAGE_CODES.includes(lng) ? lng : DEFAULT_LANGUAGE;
};

export default i18n;
